<template>
  <b-card class="profile-card" no-body>
    <b-card-body>
      <div class="d-flex align-items-start justify-content-between mb-1">
        <div>
          <h5 class="font-weight-bolder mb-0">{{ activeProfile }}</h5>
          <small class="text-muted">Base Template</small>
        </div>
        <b-dropdown
          variant="outline-secondary"
          no-caret
          right
          toggle-class="p-50 border-0"
          class="dropdown-3dot"
          boundary="window"
        >
          <template #button-content>
            <feather-icon icon="MoreVerticalIcon" size="18" />
          </template>
          <b-dropdown-item @click="showCreateModal = true">
            <feather-icon icon="PlusIcon" class="mr-75" />
            Create Template
          </b-dropdown-item>
          <b-dropdown-item disabled @click="$emit('edit-template', activeProfile)">
            <feather-icon icon="EditIcon" class="mr-75" />
            Edit Template
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('view-all', activeProfile)">
            <feather-icon icon="EyeIcon" class="mr-75" />
            View All
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item disabled
            class="text-danger"
            link-class="text-danger"
            @click="$emit('delete-template', activeProfile)"
          >
            <feather-icon icon="Trash2Icon" class="mr-75" />
            Delete Template
          </b-dropdown-item>
        </b-dropdown>
      </div>

    </b-card-body>

    <CreateTemplateModal
      v-model="showCreateModal"
      :base-template="activeProfile"
      @create="handleCreateTemplate"
    />
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BBadge,
} from "bootstrap-vue";
import { mapState } from "vuex";
import CreateTemplateModal from "./CreateTemplateModal.vue";

export default {
  name: "ProfileCard",
  components: {
    BCard,
    BCardBody,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BBadge,
    CreateTemplateModal,
  },
  props: {
    summary: {
      type: Object,
      default: () => ({
        customers: 0,
        templates: 0,
        activePercent: 0,
        racing: 0,
        sports: 0,
      }),
    },
  },
  data() {
    return {
      showCreateModal: false,
    };
  },
  computed: {
    ...mapState({
      activeProfile: (state) => state.bettingConfig.list.activeProfile,
    }),
  },
  methods: {
    getStatusVariant(status) {
      const map = {
        Active: "success",
        Review: "warning",
        Inactive: "secondary",
      };
      return map[status] || "secondary";
    },
    handleCreateTemplate({ baseTemplate, name }) {
      this.$router.push({
        name: "settings-create-betting-template",
        query: { baseTemplate, name },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-card {
  border-radius: 0.75rem;
}
.dropdown-3dot ::v-deep .btn {
  background: transparent !important;
  box-shadow: none !important;
}
</style>
